
































































































































































import Vue, { PropType } from 'vue';
import TopBar from '@/components/widgets/TopBar.vue';
import WidgetWrapper from '@/components/widgets/WidgetWrapper.vue';
import Button from '@/components/form/Button.vue';
import filterParams from '@/components/table/utils/filterParameters';
import FieldInput from '@/components/form/FieldInput.vue';
import FieldSelect from '@/components/form/FieldSelect.vue';
import FieldFile from '@/components/form/FieldFile.vue';
import FieldDatePicker from '@/components/form/FieldDatePicker.vue';
import Preloader from '@/components/preloader/Preloader.vue';
import InlinePixel from '@/components/campaign/targets/retarget/inlinePixel/InlinePixel.vue';
import { ESource, Pixel } from '@/types/audience/audience';
import { DropdownList, TFile } from '@/types';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  name: 'AudienceForm',
  components: {
    Preloader,
    TopBar,
    WidgetWrapper,
    Button,
    FieldInput,
    FieldSelect,
    InlinePixel,
    FieldDatePicker,
    FieldFile,
  },

  props: {
    loadData: {
      type: Boolean,
      default: false,
    },
    pixelsList: {
      type: Array as PropType<Array<Pixel>>,
      default: () => [],
    },
    siteTimes: {
      type: Array as PropType<Array<DropdownList>>,
      default: () => [],
    },
    pageName: {
      type: String,
    },
  },

  beforeDestroy() {
    this.$store.dispatch('audience/clearAudienceData');
  },

  computed: {
    ...mapGetters({
      audience: 'audience/getAudience',
      isSavingForm: 'audience/getIsSavingForm',
    }),
    routerBack() {
      const backUrl = filterParams.getUrlBack() || '';
      this.$emit('setBackUrl', backUrl);
      return backUrl;
    },
    title(): string {
      return (
        this.audience.name || `${this.$t('pages.audienceForm.subTitle')} #1`
      );
    },
    activityPeriod(): any {
      return [this.audience.fromDate, this.audience.toDate];
    },
    sources(): Array<DropdownList> {
      return [
        {
          label: 'Website visitors',
          value: 'visitors',
        },
        {
          label: 'Customer List',
          value: 'customers',
        },
      ];
    },
    isVisitors(): string {
      return ESource.VISITORS;
    },
    isCustomers(): string {
      return ESource.CUSTOMERS;
    },
  },

  methods: {
    ...mapActions({
      updateAudience: 'audience/updateAudienceData',
    }),
    submitForm() {
      this.$emit('submit');
    },
    closeForm() {
      this.$router.push(this.routerBack);
    },
    changePeriod(date) {
      this.updateAudience({ name: 'fromDate', value: date[0] });
      this.updateAudience({ name: 'toDate', value: date[1] });
    },
    selectFile(files: Array<TFile>): void {
      const file = files[0];
      if (file) {
        this.updateAudience({ name: 'fileName', value: file.name });
        this.updateAudience({ name: 'fileData', value: file.data });
        return;
      }

      this.updateAudience({ name: 'fileName', value: '' });
      this.updateAudience({ name: 'fileData', value: null });
    },
  },
});
